import { Dispatch } from 'react';
import Cookies from 'js-cookie';
import { Action } from 'store/User/Reducer';
import { userApiRequests } from 'utils/api-requests/user';
import { Platform } from 'utils/hooks/usePlatform';
import { isAllowedDomain } from 'utils/isAllowedDomain';
import { v4 } from 'uuid';

import { activeNotification } from 'components/functions/activeNotification';

interface PerformLogoutParams {
    dispatch: Dispatch<Action>;
    isWordpressUser: boolean;
    platform: Platform;
    onAfterDispatch?: () => void;
}

export const performLogout = async ({
    dispatch,
    isWordpressUser,
    platform,
    onAfterDispatch
}: PerformLogoutParams): Promise<void> => {
    localStorage.removeItem('MonitorApiToken');
    localStorage.removeItem('MonitorApiRefreshToken');
    localStorage.removeItem('MonitorRoles');
    localStorage.removeItem('smsInfoShown');
    localStorage.removeItem('tokenInfoShown');

    if (!isAllowedDomain(window.location.hostname)) {
        Cookies.remove('MonitorApiToken', { domain: '.investoro.pl' });
        Cookies.remove('MonitorApiRefresh', { domain: '.investoro.pl' });
        Cookies.remove('MonitorRoles', { domain: '.investoro.pl' });
    }

    if (isAllowedDomain(window.location.hostname)) {
        Cookies.remove('MonitorApiToken', { path: '/' });
        Cookies.remove('MonitorApiRefresh', { path: '/' });
        Cookies.remove('MonitorRoles', { path: '/' });
    }

    try {
        await userApiRequests.logout();
    } catch (error) {
        const errorId = v4();
        userApiRequests.logException(error as Error, errorId);
        activeNotification('Błąd wylogowania', 'Błąd komunikacji z serwerem podczas wylogowywania.', 'warning');
    } finally {
        dispatch({ type: 'LOGOUT' });
        onAfterDispatch?.();

        if (isWordpressUser && platform === Platform.Web) {
            window.location.replace('https://investoro.pl/logout.php');
        } else {
            window.location.replace('/');
        }
    }
};
